import React from 'react';
import { string, func, arrayOf, shape, bool } from 'prop-types';
import styled, { css } from 'styled-components';
import theme from '@airasia-common/libraries/theming/theme';

import Text from '../Text/Text';
import Row from '../Container/Row';

const activeBtnStyle = css`
  border: 1px solid
    ${({ theme, move }) =>
      move ? theme.colors.secondaryMove : theme.colors.greyLight};
  background: ${({ theme, move }) =>
    move ? theme.colors.secondaryMove : theme.colors.secondary};
  color: ${theme.colors.primaryWhite};
`;

const OptionLabel = styled(Text)`
  width: 63px;
  height: 32px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${({ active }) => active && activeBtnStyle}
  border-radius: 30px;
  cursor: ${({ isDeselectEnabled }) => (isDeselectEnabled ? 'pointer' : '')};
`;

OptionLabel.defaultProps = {
  margin: '4px',
  fontSize: '14px',
  fontWeight: 500,
  color: 'darkBlack',
  border: '1px solid',
  borderColor: 'greyLight',
};

const GuestRatingSelection = ({
  selectedId,
  onChange,
  options,
  isDeselectEnabled,
  isMoveEnabled,
}) => {
  return (
    <Row flexWrap="wrap">
      {options.map(item => (
        <OptionLabel
          className="guest-rating-options"
          active={item.id === selectedId.toString()}
          key={item.id}
          onClick={() => {
            onChange(item);
          }}
          isDeselectEnabled={isDeselectEnabled}
          move={isMoveEnabled}
        >
          {item.text}
        </OptionLabel>
      ))}
    </Row>
  );
};

GuestRatingSelection.propTypes = {
  onChange: func,
  selectedId: string,
  options: arrayOf(
    shape({
      id: string,
      text: string,
    })
  ),
  isDeselectEnabled: bool,
  isMoveEnabled: bool,
};

GuestRatingSelection.defaultProps = {
  onChange: () => {},
  selectedId: '',
  options: [],
  isDeselectEnabled: false,
  isMoveEnabled: false,
};

export default GuestRatingSelection;
